<template>
  <section class="has-text-centered column">
    <div>
      <p>
        El N° Documento
        <span class="has-text-weight-bold">
          {{ document }}
        </span>
        no cuenta con Productos.
      </p>
      <span class="has-text-weight-bold">
        Ingresa otro documento.
      </span>
      <hr />
      <Button variant="gray" @click.native="goBack">
        Regresar
      </Button>
    </div>
  </section>
</template>

<script>
import Button from "@/components/form/Button";
export default {
  components: {
    Button
  },
  props: {
    document: String
  },
  methods: {
    goBack() {
      this.$emit("goBack", 0);
    }
  }
};
</script>
